import { render, staticRenderFns } from "./CnidForm.vue?vue&type=template&id=45806182&scoped=true&"
import script from "./CnidForm.vue?vue&type=script&lang=js&"
export * from "./CnidForm.vue?vue&type=script&lang=js&"
import style0 from "./CnidForm.vue?vue&type=style&index=0&id=45806182&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45806182",
  null
  
)

export default component.exports